import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d6e409dc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d6e409dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e409dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6e409dc')) {
      api.createRecord('d6e409dc', component.options)
    } else {
      api.reload('d6e409dc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d6e409dc&scoped=true&", function () {
      api.rerender('d6e409dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CLctfy2rxxAH/JS/comp/GuestBox.vue"
export default component.exports